import { Stack, YStack } from '@mythical/ui'
import { IconLock } from 'app/components/primitive/Icon'
import { SolitoImage } from 'solito/image'

type ContentLockThumbnailProps = {
  image?: string
}

const ContentLockThumbnail = ({ image }: ContentLockThumbnailProps) => {
  return (
    <YStack fs={1} fg={1} position="relative" zIndex="$1" br="$3" overflow="hidden">
      <Stack pos="absolute" w="100%" h="100%" zIndex={100} bg="$backdrop" />
      <Stack w="100%" bg="$bgPrimary" aspectRatio={16 / 9}>
        {image && (
          <SolitoImage
            src={image}
            fill
            contentFit="cover"
            alt="Content thumbnail"
            // (Width - sidebar) on large screens
            sizes="100vw, (min-width: 768px) calc(100vw - 320px), (min-width: 1700px) 1400px"
          />
        )}
      </Stack>
      <Stack
        pos="absolute"
        jc="center"
        ai="center"
        w="100%"
        h="100%"
        zIndex={100}
      >
        <IconLock size={32} />
      </Stack>
    </YStack>
  )
}

export default ContentLockThumbnail
